<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Bilan retraite" subTitle="" srcImg="/images/pages/transition-pro/desc-picture.png"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="bilan-retraite" breadcrumb1="" breadcrumb2="Bilan retraite" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Transition professionnelle : le bilan retraite",
  meta: [
    {
      name: "description",
      content: "L'accompagnement bilan retraite s’adresse à tout actif terminant prochainement son activité et souhaitant préparer ce changement en toute sérénité"
    }
  ]
})
</script>

<style scoped>
.body {
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>